import Api from "../../tools/service";
import {Reoverlay} from "reoverlay";
import ErrorModal from "../modals/ErrorModal";
import * as Yup from "yup";
import {calculateOtpTimer, persianToEnglish} from "../../tools/helpers";
import {useFormik} from "formik";
import React, {useContext, useRef, useState} from "react";
import Button from "../Button";
import {PiIdentificationCardThin} from "react-icons/pi";

import DivarInternalCarContext from "../../tools/contexts/DivarInternalCarContext";
import CharactersModal from "../modals/CharactersModal";
import REQUEST_URLS from "../../tools/defaults/requestUrl";
import OTP from "../carOriginality/OTP";
import requestOTP from "../../tools/api/divarInternalCService/requestOTP";
import confirmOTP from "../../tools/api/divarInternalCService/confirmOTP";
import Switch from "react-switch";

const otpConfig = {
    title: 'کد اعتبار سنجی',
    length: 5,
}
const InitConfirm = () => {
    const divarInternalContext = useContext(DivarInternalCarContext)
    const [loading, setLoading] = useState(false);
    const inputRefs = useRef([]);
    const [input1, setInput1] = useState((divarInternalContext.process && divarInternalContext.process?.plate) ? divarInternalContext.process?.plate[0] : null)
    const [input2, setInput2] = useState((divarInternalContext.process && divarInternalContext.process?.plate) ? divarInternalContext.process?.plate[1] : null)
    const [input3, setInput3] = useState((divarInternalContext.process && divarInternalContext.process?.plate) ? divarInternalContext.process?.plate[2] : null)
    const [input4, setInput4] = useState((divarInternalContext.process && divarInternalContext.process?.plate) ? divarInternalContext.process?.plate[3] : null);
    const [otpRequired, setOtpRequired] = useState(false);
    const [otpRequestLoading, setRequestOtpLoading] = useState(false);
    const [otpConfirmLoading, setOtpConfirmLoading] = useState(false);
    const [otpError, setOtpError] = useState(false);
    const [otpTimer, setOtpTimer] = useState(120)
    const [otpDescription, setOtpDescription] = useState(null);
    const [accessToOwner, setAccessToOwner] = useState(!!divarInternalContext.process.i_have_access_to_owner && !divarInternalContext.process.im_owner);

    const [isOwner, setIsOwner] = useState((divarInternalContext.process.im_owner===null || divarInternalContext.process.im_owner===undefined) ? true : divarInternalContext.process.im_owner);
    const handleOwner = (value) => {
        if (value) {
            formik.setFieldValue('Mobile', divarInternalContext.process?.platform_user)
            setAccessToOwner(false)
        }else {
            setAccessToOwner(true)
        }
        setIsOwner(value)

    }
    const handleAccessToOwner = (value) => {
        setAccessToOwner(value);
        if(value){
            setIsOwner(false)
        }else {
            setIsOwner(true)
            formik.setFieldValue('Mobile', divarInternalContext.process?.platform_user)
        }


    }

    const handleRequestOTP = async () => {
        setRequestOtpLoading(true);
        setOtpError(null);

        const response = await requestOTP(divarInternalContext.token, {pid: divarInternalContext.pid});
        setLoading(false);
        setRequestOtpLoading(false)
        if (response.hasError) {
            setOtpError(response.message);
        } else {
            const time = calculateOtpTimer(response.data.created_at, 120);
            setOtpTimer(time);
            setOtpRequired(true)
            setOtpDescription(response.message)
        }
    }
    const handleConfirmOTP = async (code) => {
        setOtpConfirmLoading(true);
        setOtpError(null);
        const params = {
            code: code,
            pid: divarInternalContext.pid,
        }
        const response = await confirmOTP(divarInternalContext.token, params);
        setOtpConfirmLoading(false)
        if (response.hasError) {
            setOtpError(response.message);

        } else {
            divarInternalContext.handleGetProcess(divarInternalContext.pid)
        }
    }
    const openModal = () => {

        Reoverlay.showModal(CharactersModal, {
            onSelect: handleSelectCharacter
        })
    }
    const handleSelectCharacter = (value) => {
        setInput2(value);
        inputRefs.current[2].focus();
    }
    const handleSubmit = (values) => {

        if ((!input1 || !input2 || !input3 || !input4) || (input1.length !== 2 || input2.length !== 1 || input3.length !== 3 || input4.length !== 2)) {
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: 'پلاک خودرو را وارد کنید.',
                showCancelButton: true,
                onCancel: () => Reoverlay.hideModal()
            })
            return
        }
        setLoading(true);
        const params={
            NationalId: persianToEnglish(values.NationalId),
            pid: divarInternalContext.pid,
            PlateNumber: [persianToEnglish(input1), persianToEnglish(input2), persianToEnglish(input3), persianToEnglish(input4)],
            Mobile:persianToEnglish(values.Mobile),
            "im_owner": isOwner,
            "i_have_access_to_owner": accessToOwner,
        }


        Api.put(REQUEST_URLS.DIVAR_INTERNAL_CAR.INIT_CONFIRM,params , {
            headers: {
                "Authorization": `Bearer ${divarInternalContext.token}`
            }
        }).then((async response => {
            const {data, status, message, hasError} = response;
            if (hasError) {
                setLoading(false)
                divarInternalContext.handleError({
                    status,
                    message,
                    data,
                    pid: divarInternalContext.pid,
                    callback: () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message || 'خطای سرویس',
                            onConfirm: () => {

                            },
                            confirmButtonText: '',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'بستن',
                            cancelButtonTheme: 'red',
                            onCancel: () => {
                                Reoverlay.hideModal();

                            }
                        })
                    }
                })
            } else {
                if (data.otp_required) {
                    setOtpRequired(true);
                    await handleRequestOTP();

                } else {
                    divarInternalContext.handleGetProcess(divarInternalContext.pid);
                }

            }
        })).catch(e => {

        })
    }
    const ValidationSchema = Yup.object().shape({
        Mobile:Yup.string().matches(/^(09|۰۹)[0-9۰-۹]{9}$/, 'شماره موبایل نامعتبر می‌باشد.').required('شماره موبایل الزامیست.'),
        NationalId: Yup.string()
            .min(10, 'کد ملی عددی ۱۰ رقمی می باشد.')
            .max(10, 'کد ملی عددی ۱۰ رقمی می باشد.')
            .required('  کد ملی را وارد کنید.').test("isNumber", " کد ملی عددی می باشد", (value) => {
                if (!value) {
                    return false
                }
                return !isNaN(persianToEnglish(value))
            }),

    });
    const formik = useFormik({
        initialValues: {
            NationalId: divarInternalContext.process?.national_id || '',
            Mobile:divarInternalContext?.process?.confirmed_data?.Mobile||divarInternalContext.process.platform_user ,
        },
        validationSchema: ValidationSchema,
        onSubmit: handleSubmit,
    });
    const handleInputChange = (event, index) => {
        const {key, target} = event;
        switch (index) {
            case 0: {
                if (key === 'Backspace' && input1.length > 0) {

                    setInput1(input1.slice(0, -1))

                } else if (key === 'Delete' && input1.length === 0) {

                }
                break;
            }
            case 1: {

                if (key === 'Backspace' && input2.length > 0) {
                    setInput2(input2.slice(0, -1))

                } else if (key === 'Backspace' && input2.length === 0) {
                    inputRefs.current[index - 1].focus();
                }
                break;
            }
            case 2: {
                if (key === 'Backspace' && input3.length > 0) {
                    setInput3(input3.slice(0, -1))

                } else if (key === 'Backspace' && input3.length === 0) {
                    inputRefs.current[index - 1].focus();
                }

                break;
            }
            case 3: {
                if (key === 'Backspace' && input4.length > 0) {
                    setInput4(input4.slice(0, -1))

                } else if (key === 'Backspace' && input4.length === 0) {
                    inputRefs.current[index - 1].focus();
                }
                break;
            }
            default: {

            }
        }


    };
    const PlaqueChange = (index, e) => {
        const {value, key} = e.target;

        switch (index) {
            case 0: {

                if (value && value.length === 2) {
                    inputRefs.current[index + 1].focus();
                }

                if (value.length < 3) {
                    if (!isNaN(persianToEnglish(value)))
                        setInput1(persianToEnglish(value))
                }
                break;
            }
            case 1: {

                if (value && value.length === 1) {
                    inputRefs.current[index + 1].focus();
                }
                if (value.length < 2) {

                    setInput2(persianToEnglish(value))
                }
                break;
            }
            case 2: {

                if (value && value.length === 3) {
                    inputRefs.current[index + 1].focus();
                }
                if (value.length < 4) {
                    if (!isNaN(persianToEnglish(value)))
                        setInput3(persianToEnglish(value))
                }
                break;
            }
            case 3: {
                if (value.length < 3) {
                    if (!isNaN(persianToEnglish(value)))
                        setInput4(persianToEnglish(value))
                }
                if (value && value.length === 2) {

                } else {

                }
                break;
            }
            default: {

            }
        }
    };
    if (otpRequired) {
        return <OTP key={otpTimer} length={otpConfig.length}
                    title={otpConfig.title}
                    timerCount={otpTimer}
                    handleRequestOTP={handleRequestOTP}
                    confirmLoading={otpConfirmLoading}
                    retryLoading={otpRequestLoading}
                    handleConfirm={handleConfirmOTP}
                    error={otpError}
                    description={otpDescription}
        />
    }
    return <div className="w-11/12 md:w-6/12 mx-auto">

        <div className="border-b   items-center flex justify-start   my-2 pb-2 ">
            <div className="p-3 flex justify-center items-center bg-green-200 rounded-full   ">
                <PiIdentificationCardThin className="text-3xl text-green-700 "/>
            </div>
            <div className="p-2 mt-1 ">
                <h1 className="font-semibold ">تکمیل اطلاعات </h1>
                <p className="text-sm">برای ادامه فرایند اطلاعات زیر را تکمیل کنید</p>

            </div>
        </div>

        <div>
            <span className="text-sm">پلاک خودرو را وارد کنید</span>
            <div dir="ltr"
                 className="bg-white border  mt-1  w-full plaque-card  overflow-hidden rounded-xl grid grid-cols-12 gap-4  ">
                <div
                    className="h-full bg-blue-900 flex-col  flex justify-center items-center   border-b border-gray-200  col-span-3">

                    <div className="w-full justify-start items-start px-3  flex-col flex">
                        <div className=" flex flex-col  ">
                            <div className="bg-green-600 w-4 h-1"/>
                            <div className="bg-white w-4 h-1"/>
                            <div className="bg-red-600 w-4 h-1"/>
                        </div>
                        <span className="text-white mt-2  text-xs ">IRAN</span>

                    </div>
                </div>
                <div className="h-full col-span-2 flex items-end">
                    <input onKeyDown={(event) => handleInputChange(event, 0)} value={input1}
                           ref={(inputRef) => (inputRefs.current[0] = inputRef)} onChange={(e) => {
                        PlaqueChange(0, e)
                    }} dir="ltr" placeholder="--"
                           className="text-center h-full  w-full outline-none   text-sm   border-gray-200 " type="tel"/>
                </div>
                <div className="h-full col-span-2 flex items-end">
                    <input onKeyDown={(event) => handleInputChange(event, 1)} onFocus={openModal} readOnly
                           value={input2} ref={(inputRef) => (inputRefs.current[1] = inputRef)} onChange={(e) => {
                        PlaqueChange(1, e)
                    }} dir="ltr" placeholder="-" className="h-full text-center w-full  outline-none   text-sm border-gray-200 "
                           type="text"/>
                </div>
                <div className="h-full col-span-3 flex items-end">
                    <input onKeyDown={(event) => handleInputChange(event, 2)} value={input3}
                           ref={(inputRef) => (inputRefs.current[2] = inputRef)} onChange={(e) => {
                        PlaqueChange(2, e)
                    }} dir="ltr" placeholder="---"
                           className="h-full text-center w-full  outline-none text-sm   border-gray-200 " type="tel"/>
                </div>

                <div className="h-full col-span-2 flex items-end">
                    <input onKeyDown={(event) => handleInputChange(event, 3)} value={input4}
                           ref={(inputRef) => (inputRefs.current[3] = inputRef)} onChange={(e) => {
                        PlaqueChange(3, e)
                    }} dir="ltr" placeholder="--"
                           className="h-full text-center w-full outline-none  text-sm border-l  border-gray-200 " type="tel"/>
                </div>

            </div>
        </div>
        <form className="bg-white p-5 mt-2  rounded-xl " onSubmit={formik.handleSubmit}>
            <label className="text-sm  " htmlFor="NationalId">کد ملی مالک </label>
            <input dir="ltr" onChange={formik.handleChange}
                   value={formik.values.NationalId} type="tel"
                   className={`w-full mt-1  bg-gray-100 text-sm  text-right rounded-xl p-3 `}
                   placeholder="کد ملی را وارد کنید"
                   name="NationalId"/>
            {formik.errors.NationalId && formik.touched.NationalId ? (
                <p className="text-red-400  text-sm font-light mt-1 ">{formik.errors.NationalId}</p>
            ) : null}

            <label className="text-sm " htmlFor="Mobile">شماره موبایل مالک</label>
            <input dir="ltr" onChange={formik.handleChange} disabled={isOwner} value={formik.values.Mobile} type="tel"
                   className={`w-full mt-1 bg-gray-100 text-sm text-right rounded-xl p-3 ${isOwner ? 'bg-gray-200 opacity-40': ''}`}
                   placeholder="شماره موبایل"
                   name="Mobile"/>
            {formik.errors.Mobile && formik.touched.Mobile ? (
                <p className="text-red-400 text-sm font-light mt-1 ">{formik.errors.Mobile}</p>
            ) : null}
            <>
                <div className="grid grid-cols-1 mt-1 border-t">
                    <div onClick={() => {
                        handleOwner(!isOwner)
                    }} className="w-full  justify-between p-3   flex items-center">
                        <span className="text-sm ">مالک خودرو هستم.</span>
                        <Switch onColor="#36b570" height={20} width={40} uncheckedIcon={false} checkedIcon={false}
                                checked={isOwner}
                                onChange={handleOwner}/>
                    </div>
                </div>
                <div onClick={() => {
                    handleAccessToOwner(!accessToOwner)
                }} className="w-full      border-t    ">
                    <div className="justify-between flex p-3 items-center">
                        <span className="text-sm ">به مالک دسترسی دارم.</span>
                        <Switch onColor="#36b570" height={20} width={40} uncheckedIcon={false} checkedIcon={false}
                                checked={accessToOwner}
                                onChange={handleAccessToOwner}/>
                    </div>
                    <p className="text-sm  border-t p-3 ">با فعال‌سازی گزینه به مالک دسترسی دارم، کد اعتبارسنجی به شماره
                        تلفن مالک خودرو ارسال خواهد شد.</p>

                </div>
            </>
            <Button loading={loading} className="text-sm mt-5 border-t border-gray-200 w-full rounded-lg " theme="green"
                    type={"submit"}>ادامه</Button>
        </form>
    </div>
}
export default InitConfirm;